export default __webpack_public_path__ + "src/assets/icn-toast-success.b63989deab52c679437619f0488ed98b.svg";